<template>
  <div>
    <b-card
      :header="$t('privileges')"
      header-tag="header"
      class="header m-0 h-100"
    >
      <Badge
        class="px-2 py-1 mb-1"
        variant="primary"
        :value="value.privileges"
      />
    </b-card>
  </div>
</template>

<script>
import Badge from '../Badge'
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    Badge
  }
}
</script>
